import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { callApi } from "../../api";
import {
  formatServiceCategories,
  parseJSON,
} from "../../utility/CustomFunction";
import { useAuth } from "../useAuth";

export default () => {
  const [employeeData, setEmployeeData] = useState(null);
  const [employeeReport, setEmployeeReport] = useState(null);
  const [employeeSkills, setEmployeeSkills] = useState(null);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const { selectedBusiness, runWithGuard } = useAuth();

  const maxEmployeeOrder =
    (+Math.max(...(employeeData || [])?.map((x) => +x.order || 0), 0) || 0) + 1;

  const [allRoles, setAllRoles] = useState(null);

  const [staffAclSetting, setStaffAclSetting] = useState();

  const [allStaffAcl, setAllStaffAcl] = useState([]);

  const getEmployeeData = async (includeDeleted = false) => {
    setEmployeeLoading(true);
    runWithGuard(async () => {
      if (includeDeleted) {
        const res = await callApi(
          `/protected/business/${selectedBusiness.id}/getemployees`
        );
        const res2 = await callApi(
          `/protected/business/${selectedBusiness.id}/getemployees?deleted=1`
        );
        if (res && res.status === true && res2 && res2.status === true) {
          setEmployeeData([...res.data, ...res2.data]);
          // setEmployeeData(res.data);
          setEmployeeLoading(false);
        } else {
          toast.error((res && res.message) || "Failed to fetch employees!");
          setEmployeeLoading(false);
        }
      } else {
        const res = await callApi(
          `/protected/business/${selectedBusiness.id}/getemployees`
        );
        if (res && res.status === true) {
          setEmployeeData(res.data);
          setEmployeeLoading(false);
        } else {
          toast.error((res && res.message) || "Failed to fetch employees!");
          setEmployeeLoading(false);
        }
      }
    });
  };

  const getEmployees = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/getemployees`
    );
    if (res && res.status === true) {
      return res?.data;
    }
    toast.error((res && res.message) || "Failed to fetch employees!");

    return null;
  };

  const addEmployee = async (addData) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/staff/add`,
      "POST",
      { ...addData, order: maxEmployeeOrder + 100 * Math.random() }
    );
    return res;
  };

  const getEmployeeReport = async (month, year) => {
    setEmployeeLoading(true);
    runWithGuard(async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/monthlyreport/${month}/${year}`
      );
      if (res && res.status === true) {
        setEmployeeReport(res.data);
        setEmployeeLoading(false);
      } else {
        toast.error(res?.message || "Failed to fetch employees!");
        setEmployeeLoading(false);
      }
    });
  };

  const getEmployeeSkills = async () => {
    // setEmployeeLoading(true)
    const func = async () => {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/getservices`
      );
      if (res && res.status === true) {
        setEmployeeSkills(
          formatServiceCategories(res.data?.filter((x) => !x.giftcard))
        );
        setEmployeeLoading(false);
      } else {
        toast.error(res.message || "Failed to fetch employees!");
        setEmployeeLoading(false);
      }
    };
    runWithGuard(func);
  };

  const getStaffAcl = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/iorequest?dest=staffacl/:BID:/get`,
      "GET"
    );
    if (res?.data?.[0]) {
      setStaffAclSetting(parseJSON(res?.data?.[0]?.value));
    } else {
      setStaffAclSetting();
    }
    return res;
  };

  const fetchAllStaffAcl = async () => {
    // const res = await callApi(
    //   `/protected/business/${selectedBusiness?.id}/staffrolesparams/all`
    // );
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/systemsettings/uzeli-staff-pin-params`)}`
    );

    // if (res?.status) setAllStaffAcl(res.data);
    if(res && res?.success) {
      const pinParams = parseJSON(res?.data?.[0]?.configurations)
      if(pinParams) setAllStaffAcl(pinParams);
    }
  };

  const updateStaffAclSetting = async (aclSettings) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/iorequest?dest=staffacl/:BID:/update`,
      "POST",
      { settings: aclSettings }
    );
    if (res?.status) {
      setStaffAclSetting(aclSettings);
    }
    return res;
  };

  const updateEmployeeName = async (eid, name, resource) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/staff/${eid}/property/update`,
      "POST",
      {
        id: eid,
        key: "full_name",
        value: name,
      }
    );
    if (res && res.status) {
      setEmployeeData([...employeeData.filter((x) => x.id !== eid), res?.data]);
      toast.success(
        !resource
          ? "Username updated successfully."
          : "Resource name updated successfully."
      );
    } else {
      toast.error(res?.message || "Failed to update username");
    }
    return res;
  };

  const updateEmployeeProperty = async (eid, key, value, isResource) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/staff/${eid}/property/update`,
      "POST",
      {
        id: eid,
        key,
        value,
      }
    );
    if (res && res.status) {
      setEmployeeData([...employeeData.filter((x) => x.id !== eid), res?.data]);
      toast.success(
        !isResource
          ? "Employee updated successfully."
          : "Resource updated successfully."
      );
    } else {
      toast.error(res?.message || "Failed to update employee");
    }
    return res;
  };

  const updateEmployeeAppointmentVisibility = async (
    eid,
    visibility,
    hideToast=false
  ) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/staff/${eid}/property/update`,
      "POST",
      {
        id: eid,
        key: "visible_in_appointment",
        value: visibility,
      }
    );
    if (res && res.status) {
      setEmployeeData([...employeeData.filter((x) => x.id !== eid), res?.data]);
      if (!hideToast)
        toast.success("Successfully updated appointment visibility");
    } else {
      toast.error(res?.message || "Failed to update appointment visibility");
    }
    return res;
  };

  const updateEmployeeData = (data) => {
    setEmployeeData(
      employeeData.map((x) => (x.id === data.id ? { ...x, ...data } : x))
    );
  };

  const updateBulkEmployeeData = (data = []) => {
    setEmployeeData(
      employeeData.map((x) => {
        const foundEmp = data?.find((st) => st.id === x.id);
        if (foundEmp) return { ...x, ...foundEmp };
        return x;
      })
    );
  };

  const getEmployeeAppointments = async (id) =>
    callApi(
      `/protected/business/${selectedBusiness.id}/artist/${id}/appointments`
    );

  const getAllEmployeeRoles = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/allroles`
    );
    if (res?.status) {
      setAllRoles(res.data);
    }
  };

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    setEmployeeSkills(undefined);
    setEmployeeData(undefined);
    setAllRoles(null);
    setStaffAclSetting(undefined);
  }, [selectedBusiness?.id]);

  return {
    employeeData,
    employeeLoading,
    employeeReport,
    employeeSkills,
    staffAclSetting,
    allStaffAcl,
    allRoles,
    addEmployee,
    setAllRoles,
    getAllEmployeeRoles,
    getEmployeeData,
    getEmployeeReport,
    getEmployeeSkills,
    getStaffAcl,
    updateEmployeeName,
    updateEmployeeData,
    updateBulkEmployeeData,
    getEmployees,
    fetchAllStaffAcl,
    getEmployeeAppointments,
    updateStaffAclSetting,
    updateEmployeeAppointmentVisibility,
    updateEmployeeProperty,
  };
};
